import React, { useState, useEffect } from "react";
import "../style/cookie-banner.scss";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isDelayed, setIsDelayed] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [cookies, setCookies] = useState({
    necessary: true, // Notwendige Cookies können nicht deaktiviert werden
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDelayed(false);
    }, 3000); // 1 second delay

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const consent = typeof window !== "undefined" && localStorage.getItem("cookieConsent");
    if (!consent && !isDelayed) {
      setShowBanner(true);
    }
  }, [isDelayed]);

  const handleAcceptAll = () => {
    const allCookies = {
      necessary: true,
      analytics: true,
      marketing: true,
    };
    setCookies(allCookies);
    savePreferences(allCookies);
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    savePreferences(cookies);
    setShowBanner(false);
  };

  const savePreferences = (prefs) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("cookieConsent", JSON.stringify(prefs));
    }
    console.log("Cookie-Einstellungen gespeichert:", prefs);
  };

  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };

  const handleCookieToggle = (cookieType) => {
    // Notwendige Cookies können nicht deaktiviert werden
    if (cookieType === "necessary") return;

    setCookies((prev) => ({
      ...prev,
      [cookieType]: !prev[cookieType],
    }));
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <h3 style={{ marginBottom: "0px" }}>Cookie-Einstellungen</h3>
        <p>
          Wir verwenden Cookies, um Ihnen das beste Erlebnis auf unserer Website
          zu bieten. 
        </p>

        {showSettings && (
          <div className="cookie-settings">
            <div className="cookie-option">
              <label className="toggle-container">
                <div className="cookie-text">
                  <span className="cookie-label">Notwendige Cookies</span>
                  {/* <span className="cookie-description">
                    Erforderlich für die Grundfunktionen der Website
                  </span> */}
                </div>
                <div className="toggle-wrapper">
                  <input
                    type="checkbox"
                    checked={cookies.necessary}
                    disabled
                    className="toggle-input"
                  />
                  <span className="toggle-slider"></span>
                </div>
              </label>
            </div>

            <div className="cookie-option">
              <label className="toggle-container">
                <span className="cookie-label">Analytics</span>
                <div className="toggle-wrapper">
                  <input
                    type="checkbox"
                    checked={cookies.analytics}
                    onChange={() => handleCookieToggle("analytics")}
                    className="toggle-input"
                  />
                  <span className="toggle-slider"></span>
                </div>
              </label>
            </div>

            <div className="cookie-option">
              <label className="toggle-container">
                <span className="cookie-label">Marketing</span>
                <div className="toggle-wrapper">
                  <input
                    type="checkbox"
                    checked={cookies.marketing}
                    onChange={() => handleCookieToggle("marketing")}
                    className="toggle-input"
                  />
                  <span className="toggle-slider"></span>
                </div>
              </label>
            </div>
          </div>
        )}

        <div className="cookie-actions">
          <button className="btn-settings" onClick={toggleSettings}>
            {showSettings
              ? "Einstellungen ausblenden"
              : "Einstellungen anpassen"}
          </button>
          <div>
            <button className="btn-accept" onClick={handleAcceptAll}>
              Alle akzeptieren
            </button>
            <button className="btn-save" onClick={handleSavePreferences}>
              Auswahl speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
